import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { IUserCreateVideoConferenceResponse } from '~/types/server.types';

export class VideoConferenceAdapter extends BaseHttpAdapter {
    createVideoConference(userId: string) {
        return this.apiService.apiRequest<IUserCreateVideoConferenceResponse>({
            method: 'post',
            url: `/api/v2/users/${userId}/video_conference`,
            networkLabel: 'createVideoConference'
        });
    }

    deleteVideoConference(userId: string, videoConferenceId: number) {
        return this.apiService.apiRequest<{}>({
            method: 'delete',
            url: `/api/v2/users/${userId}/video_conference/`,
            data: {
                meeting_id: videoConferenceId
            }
        });
    }
}
